var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { style: _vm.asideStyle() },
    [
      _c(
        "q-panel",
        { staticClass: "clearfix aside-panel" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("q-menu-bar", {
            attrs: {
              router: true,
              menus: _vm.defaultMenu,
              "is-collapse": false,
            },
          }),
          _vm._v(" "),
          _c("q-menu-bar", {
            attrs: {
              router: true,
              menus: _vm.menus,
              "is-collapse": _vm.isCollapse_,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }